export const LIQUIDACIONES_REQUEST = 'LIQUIDACIONES_REQUEST'
export const LIQUIDACIONES_SUCCESS = 'LIQUIDACIONES_SUCCESS'
export const LIQUIDACIONES_ERROR = 'LIQUIDACIONES_ERROR'

export const LIQUIDACION_RESUMEN_REQUEST = 'LIQUIDACION_RESUMEN_REQUEST'
export const LIQUIDACION_RESUMEN_SUCCESS = 'LIQUIDACION_RESUMEN_SUCCESS'
export const LIQUIDACION_RESUMEN_ERROR = 'LIQUIDACION_RESUMEN_ERROR'

export const LIQUIDACION_DETALLE_REQUEST = 'LIQUIDACION_DETALLE_REQUEST'
export const LIQUIDACION_DETALLE_SUCCESS = 'LIQUIDACION_DETALLE_SUCCESS'
export const LIQUIDACION_DETALLE_ERROR = 'LIQUIDACION_DETALLE_ERROR'